module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level6.b62f4140.png";